import * as React from 'react';

import './HRTab.pcss';

interface Props {
  selected:boolean;
  onClick:()=>void;
  className?:string;
}

export const HRTab = (props: React.PropsWithChildren<Props>)=>
  <a
    href={"#"}
    className={`hr-tab ${props.selected?" selected":""} ${props.className}`}
    onClick={(e)=>{
      e.preventDefault();
      props.onClick();
    }}
  >
    {props.children}
  </a>

